import api from 'config/api.config';
import { getErrorMessage } from 'utils/errors';

/**
 * Fetch comments settings for a specific social media account.
 * @param social_media_account_id - The ID of the social media account.
 * @returns - The comments settings data.
 */
export const getMessagesSettings = async (social_media_account_id: string): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/messages/messages-settings',
      { social_media_account_id }
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch comments settings'));
  }
};

/**
 * Update messages settings for a specific social media account.
 * @param social_media_account_id - The ID of the social media account.
 * @param is_active - The active status to set for the settings.
 * @param template_data - The template data to update.
 * @returns - The response data.
 */
export const manageMessageSettings = async (
  social_media_account_id: string,
  is_active: boolean,
  template_data: string,
  action_id: string
): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/messages/messages-settings-update',
      {
        social_media_account_id,
        action_id,
        is_active,
        template_data
      }
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to update messages settings'));
  }
};

/**
 * Fetch messages logs for a specific social media account.
 * @param account_id - The ID of the social media account.
 * @returns - The messages logs data.
 */
export const getMessagesLogs = async (
  account_id: string,
  page?: number,
  limit?: number,
  date?: string
): Promise<any> => {
  try {
    const body: Record<string, unknown> = { account_id };
    if (page !== undefined) body.page = page;
    if (limit !== undefined) body.limit = limit;
    if (date) body.date = date;

    const response = await api.post(
      '/api/actions/messages/messages-settings-logs',
      body
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch messages settings logs'));
  }
};
